'use strict';

angular.module('app').directive('removeHover', function ($timeout) {
  function link(scope, element) {
    $(document).on('click', '.currency-list li', function () {
      $(element).parent('.eur').removeClass('active');
    });
  }

  return {
    restrict: 'A',
    link: link,
  };
});
